// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityParam-Mc2EntityParam-module__box--WPwOX {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityParam-Mc2EntityParam-module__label--w7NAf {
  color: rgba(0, 0, 0, 0.55);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2EntityParam/Mc2EntityParam.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AAEA;EACE,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.label {\n  color: rgba(0, 0, 0, 0.55);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityParam-Mc2EntityParam-module__box--WPwOX`,
	"label": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityParam-Mc2EntityParam-module__label--w7NAf`
};
export default ___CSS_LOADER_EXPORT___;
